<template>
    <div class="datePicker" v-bind:class="{ 'calendar-view' : hideField }">
        <div v-bind:class="{ hide : hideField }">
            <a href="" @click.prevent="" v-bind:id="'trigger-' + pickerInputID" v-if="trigger != undefined" v-html="trigger"></a>
            <input v-bind:class="{ required : isRequired, hide : trigger != undefined }" class="calendar-field" v-bind:id="pickerInputID" type="text" v-bind:name="pickerName" v-bind:value="pickerValue" />
        </div>
        <div class="picker" v-bind:id="pickerID"></div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            if(this.type != undefined) {
                this.pickerType = this.type
            }
            if(this.value != undefined && this.value != '') {
                this.pickerValue = this.value
            }
            if(this.name != undefined) {
                this.pickerName = this.name;
                this.pickerID = this.pickerName.match(/[a-zA-Z]+/g)[0];
                this.pickerInputID = this.pickerID + '-input';
            }
            if(this.required != undefined) {
                this.isRequired = true;
            }
            if(this.minDate != undefined) {
                this.pickerMinDate = new Date(this.minDate);
            }
            if(this.maxDate != undefined) {
                this.pickerMaxDate = new Date(this.maxDate);
            }
        },
        data:function() {
            return {
                picker: false,
                pickerType:'picker',
                pickerName:'date',
                pickerID:'date',
                pickerInputID:'date-input',
                pickerValue:moment().format('M/D/YYYY'),
                hideField:false,
                isRequired:false,
                pickerMinDate:new Date(moment().format('M/D/YYYY')),
                pickerMaxDate:false
            }
        },
        props: {
            type:{type:String,default:'picker'},
            name:{type:String,default:'date'},
            value:{type:String},
            required:{type:String},
            minDate:{type:String},
            maxDate:{type:String},
            trigger:{type:String},
            triggerDrawer:{type:String}
        },
        methods: {
            openCalendar:function() {

            }
        },
        mounted:function() {
            var e = this;
            var today = moment().format('M/D/YYYY');
            if(this.pickerType == 'calendar') {
                var field = document.getElementById(this.pickerID);
                this.hideField = true;
                this.picker = new Pikaday({
                    format: 'M/D/YYYY',
                    defaultDate:new Date(e.pickerValue),
                    minDate:e.pickerMinDate,
                    maxDate:e.pickerMaxDate ? e.pickerMaxDate : false,
                    setDefaultDate:true,
                    onSelect: function(date) {
                        e.pickerValue = e.picker.toString();
                    }
                });
                field.parentNode.insertBefore(this.picker.el, field.nextSibling);
            } else {
                var e = this;
                var pickerID = e.pickerInputID;
                if(this.trigger != undefined) {
                    pickerID = 'trigger-' + e.pickerInputID;
                }
                this.picker = new Pikaday({
                    field:document.getElementById(pickerID),
                    format: 'M/D/YYYY',
                    theme:'pika-basic',
                    defaultDate:new Date(this.pickerValue),
                    minDate:e.pickerMinDate,
                    maxDate:e.pickerMaxDate ? e.pickerMaxDate : false,
                    setDefaultDate:true,
                    onSelect:function() {
                        if(e.trigger != undefined) {
                            e.pickerValue = e.picker.toString();
                        }
                        if(e.triggerDrawer != undefined) {
                            e.$root.$openDrawer(e.triggerDrawer+'?picker-date=' + e.pickerValue);
                        }
                    }
                });
            }
        }
    }
</script>
